import {
  CHANGE_FILTER,
  CONFIG_FETCH,
  CONFIG_SET,
} from "../constants/actionTypes";
import { Config } from "../types/config";

const doFetchConfig = () => ({ type: CONFIG_FETCH });

const doSetConfig = (config: Config) => ({
  type: CONFIG_SET,
  payload: config,
});

const doChangeFilter = (filter: string) => ({
  type: CHANGE_FILTER,
  payload: filter,
});

export { doFetchConfig, doSetConfig, doChangeFilter };
